import { render } from "./TablaSolicitudes.vue?vue&type=template&id=13ee7427"
import script from "./TablaSolicitudes.vue?vue&type=script&lang=js"
export * from "./TablaSolicitudes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__